{
  "en": {
    "question_list": {
      "actions": {
        "cancel": "Undo",
        "cancelOrder": "Cancel",
        "delete": "Delete",
        "deleteMultipleQuestionLists": "Delete...",
        "delete_cancel": "Cancel",
        "edit": "Edit",
        "new": "FAQ list",
        "reorderQuestions": "Reorder questions",
        "save": "Save",
        "saveOrder": "Save order",
        "submit": "Create",
        "tickBoxesDeletion": "Tick the checkboxes of the FAQs you would like to have deleted, then press the button above the confirm or cancel the deletion."
      },
      "attributes": {
        "description": "Description",
        "name": "Name",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "All Units",
        "descriptionOptional": "Description (optional)",
        "editFAQ": "Edit FAQ",
        "faq_all_projects": "FAQs all projects",
        "info": "Have a question about your home? Stay tuned for the most asked questions and their answers!",
        "questions": " No Questions | 1 Question | {count} Questions",
        "showQuestionListFor": "Show FAQ's for",
        "title": "Frequently Asked Questions"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Here you'll find answers to general questions or ones asked by others.",
            "title": "Frequently Asked Questions"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Provide answers to general questions your customers might have.",
            "title": "Create your first FAQ list"
          }
        }
      },
      "toasts": {
        "create": "FAQ List created",
        "delete": "FAQ List deleted",
        "update": "FAQ List updated"
      },
      "validation": {
        "needName": "Title required",
        "selectQuestionList": "Select at least 1 FAQ"
      }
    }
  }
}